import { getIntegration } from '@automator/builder/definitions/integrations';

/**
 * Checks if the integration is a third-party integration
 * 
 * @param {String} integrationID  The integration ID
 * @return {Boolean}              True if the integration is a third-party integration, false otherwise
 */
const isThirdParty = ( integrationID ) => {
	const integration = integrationID ? getIntegration( integrationID ) : false;
	return integration ? integration.is_third_party : false;
}

export default isThirdParty;
